<template>
	<v-app v-if="!loggingIn">
		<app-loading />
		<app-menu
			v-if="$ravello.isAuth()"
			title="Hub"
			:logo="require('@/assets/logo_white.png')"
			logo-style="margin-left: 32px; margin-top: 8px; margin-bottom: 8px; margin-right: 10px;"
			:logo-height="32"
			:items="nav"
		/>
		<app-header
			v-if="$ravello.isAuth()"
		></app-header>
		<app-main>
			<app-subscribe-bar v-if="$ravello.isAuth()" />
			<router-view></router-view>
		</app-main>
		<app-alerts />
		<app-snackbars />
		<app-footer v-if="$ravello.isAuth()" copyright="Ravello Media" class="d-none d-sm-flex"></app-footer>
	</v-app>
	<v-app v-else>
		<app-splashscreen :logo="require('@/assets/logo_white.png')" title="Hub" />
	</v-app>
</template>

<script>
import AppAlerts from '@/components/app/private/AppAlerts.vue'
import AppFooter from '@/components/app/private/AppFooter.vue'
import AppHeader from '@/components/app/private/AppHeader.vue'
import AppMain from '@/components/app/private/AppMain.vue'
import AppMenu from '@/components/app/private/AppMenu.vue'
import AppLoading from '@/components/app/private/AppLoading.vue'
import AppSplashscreen from '@/components/app/private/AppSplashscreen.vue'
import AppSnackbars from '@/components/app/private/AppSnackbars.vue'
import AppSubscribeBar from '@/components/app/private/AppSubscribeBar.vue'

import { mainNav } from '@/datasources/nav'

// @todo - Set splashscreen or loading when user is authenticating or show skeleton layout
export default {
	name: 'App',
	components: {
		AppAlerts,
		AppFooter,
		AppHeader,
		AppLoading,
		AppMain,
		AppMenu,
		AppSplashscreen,
		AppSnackbars,
		AppSubscribeBar,
	},
	computed: {
		nav() {
			return mainNav
		},
		loggingIn() {
			return this.$ravello.isAuth() && !this.$ravello.isAuthLoaded()
		},
	},
}
</script>

<style>
	.v-icon {
		font-size: 16px;
	}
	#app {
		background-color: #eee
	}
	#app .v-icon {
		font-size: 16px;
	}

	h1, h2, h3, h4, h5, h6 {
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
